import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StartMeetingComponent } from '../components/Video-calling/start-meeting/start-meeting.component';
import { VideoCallEndedComponent } from '../components/Video-calling/video-call-ended/video-call-ended.component';
import { VideoCallComponent } from '../components/Video-calling/video-call/video-call.component';
import { AuthGuard } from '../core/auth-guard';

const routes: Routes = [
  // {
  //   path: 'start-meeting/:id',
  //   component: StartMeetingComponent,
  // },
  {
    path: 'meeting/:id',
    component: VideoCallComponent,
  },
  {
    path: 'meeting/:id/:acId',
    component: VideoCallComponent,
  },
 
  {
    path : 'call-ended/:id',
    component : VideoCallEndedComponent,

  },
  {
    path:'auth/accessCode',component:VideoCallComponent
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VideoConferenceRoutingModule { }
